import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class LeadsService {
    // Get All
    static async getAllLeads(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.LEADS; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch leads.');
            return [];
        }
    }

    // Create 
    static async addNewLead(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.LEADS; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Lead added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new lead.');
        }
    }

    // Get by ID
    static async getLeadById(id) {
        // debugger
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADS}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            // console.log('get by id response modal ', responseModel)
            return responseModel;
        } else {
            throw new Error('Failed to fetch lead by ID');
        }
    }

    //create Customer From Lead
    static async createCustomerFromLead(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADS}/${id}/create-customer`; //endpoint

        responseModel = await handlePostAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Create Customer from Lead successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create customer from lead.');
        }
    }

    // Update 
    static async updateLeadById(id, data) {
        // debugger
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADS}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Lead updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update lead.');
        }
    }

    // Delete 
    static async deleteLead(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADS}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete lead.');
            }
        } catch (error) {
            console.error('Error deleting lead:', error);
            throw error;
        }
    }

    // Delete Many
    static async deleteManyLeads(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.LEADS}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
